import type { RouteObject } from "react-router-dom";

import { AccessLayout } from "@components/AccessLayout/AccessLayout";
import { CreateUser } from "@pages/AccessManager/CreateUser/CreateUser";
import { UserDetails } from "@pages/AccessManager/UserDetails/UserDetails";
import { Users } from "@pages/AccessManager/Users/Users";

import { ROUTES } from "./router.constants";

export const accessManagerRoutes: RouteObject[] = [
  {
    path: ROUTES.ACCESS_MANAGER,
    element: (
      <AccessLayout>
        <Users />
      </AccessLayout>
    ),
  },
  {
    path: ROUTES.ACCESS_MANAGER_CREATE,
    element: (
      <AccessLayout>
        <CreateUser />
      </AccessLayout>
    ),
  },
  {
    path: ROUTES.ACCESS_MANAGER_USER,
    element: (
      <AccessLayout>
        <UserDetails />
      </AccessLayout>
    ),
  },
];
